import React from 'react';
import { steps } from '../data/site';
export function Process() {
  return <section id="process" className="bg-[#0B1B2B] py-20 text-[#FFFDF6] lg:py-28" data-id="element-114" data-mp="1udljfcw90bs6">
      <div className="mx-auto w-full max-w-7xl px-5 sm:px-8" data-id="element-115" data-mp="1ufg7h02tgk0h">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between" data-id="element-116" data-mp="1ygi6pgwqgw2g">
          <div className="max-w-2xl" data-id="element-117" data-mp="23d8ny7k9xxpg">
            <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-[#FFD84D]" data-id="element-118" data-mp="23c78zs050r2g">
              How it works
            </p>
            <h2 className="mt-3 text-4xl font-black leading-[1.02] tracking-tight sm:text-5xl" data-id="element-119" data-mp="1ap4h3ipyvel6">
              Three steps. Zero hassle.
            </h2>
          </div>
          <p className="max-w-md text-lg text-[#FFFDF6]/70" data-id="element-120" data-mp="1fmw541nhqgk3">
            No estimators wandering your yard, no surprise line items. Just a clear price
            and a crew that shows up when they said they would.
          </p>
        </div>

        <ol className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-121" data-mp="ryd1hzfdyryc">
          {steps.map(step => <li key={step.number} className="relative rounded-[1.75rem] border-2 border-[#FFFDF6]/20 bg-[#0F2438] p-8" data-id="element-122" data-mp="19lhb38fx5teu">
              <span className="text-5xl font-black text-[#FFD84D]" data-id="element-123" data-mp="15m04ucso4s8m">{step.number}</span>
              <h3 className="mt-4 text-2xl font-black tracking-tight" data-id="element-124" data-mp="10qt67je9adqk">{step.title}</h3>
              <p className="mt-3 text-base leading-relaxed text-[#FFFDF6]/70" data-id="element-125" data-mp="vtb4oe2kj0sl">{step.text}</p>
            </li>)}
        </ol>

        <div className="mt-14 grid gap-8 overflow-hidden rounded-[2rem] border-4 border-[#FFD84D] bg-[#0F2438] md:grid-cols-[1fr_0.8fr] md:items-center" data-id="element-126" data-mp="lvn0yymziiya">
          <div className="p-8 sm:p-12" data-id="element-127" data-mp="hulab674vf7x">
            <h3 className="text-3xl font-black leading-tight sm:text-4xl" data-id="element-128" data-mp="cuyldzhy0aja">
              The Horizons streak-free promise
            </h3>
            <p className="mt-4 text-lg text-[#FFFDF6]/75" data-id="element-129" data-mp="2c71c9uswc76z">
              Walk the job with us when we finish. See a streak, a smudge, or a missed
              track? Point at it and we clean it again on the spot — or come back within
              seven days at no charge.
            </p>
            <a href="#quote" className="mt-7 inline-flex rounded-full border-2 border-[#0B1B2B] bg-[#FFD84D] px-7 py-3.5 text-base font-extrabold text-[#0B1B2B] transition hover:-translate-y-0.5" data-id="element-130" data-mp="2v4l0wj62tcz3">
              Book my cleaning
            </a>
          </div>
          <div className="h-64 w-full md:h-full" data-id="element-131" data-mp="3a1c4z5qp3cv1">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/4718d485-740a-43b6-8e4b-2ff3f88a25b4.jpg" alt="Uniformed technician squeegeeing a large residential window" className="h-full w-full object-cover" loading="lazy" data-id="element-132" data-mp="39zhelbwnmsjk" />
          </div>
        </div>
      </div>
    </section>;
}